import React, { useState, useEffect } from "react";
import {
  Dimensions, Linking,
  StyleSheet,
  Text,
  View
} from "react-native";

import PostList from "../Feed/PostFeed/PostList";
import {Timeline} from 'react-twitter-widgets';

import { customFeed, getAllTheme, } from "../../API/API";

import BarreRecherche from "../Header/BarreRecherche";
import TendanceList from "../Tendance/TendanceList";
import ExplorerThemeList from "../Explorer/ExplorerThemeList";
import WebView from "react-native-webview";
import BoutonGenerale from "../Bouton/BoutonGenerale";
import {filterMixedData, sortMixedData} from "../../utils/search";

const getDimensions = () => Dimensions.get('window');


const EmptyContent = ({ t }) => {
  return <View style={{paddingTop: 40,alignItems:"center"}}>
    <Text>{ t('Aucun élément à afficher') }</Text>
  </View>;
}

export const ThemeTab = ({navigation, t, item, all_themes}) => {
  const navigateToEntityScreen = (item) => {
    navigation.navigate("EntityScreen", {id: item.id, type: "theme"});
  }

  if ((item.themes || []).length === 0) {
    return <EmptyContent t={t} />
  }

  return <ExplorerThemeList
      type={"theme"}
      focusList={ item.themes }
      // prevent problem
      notificationList={[]}
      isEntityScreen={true}
      data={all_themes}
      isFocus={false}
      navigateToEntityScreen={navigateToEntityScreen}
  />;
}


export const TwitterTab = ({ t, theme, item, online }) => {
  const { height } = getDimensions();

  const isDark = theme.isDark ? "dark" :"light";
  const urlTwitter = item.extra_data.url_twitter;

  // twitter scripts are not cached
  if (!online || urlTwitter == null) {
    return <EmptyContent t={t} />
  }

  return <Timeline dataSource={{ sourceType: 'profile', screenName: urlTwitter }}
                   options={{ height: height - (height*(40/100))}}/>
}


export const FacebookTab = ({t, item, online}) => {
  const { height } = getDimensions();
  const urlFacebook = item.extra_data.url_facebook;

  // facebook scripts are not cached
  if (!online || urlFacebook == null) {
    return <EmptyContent t={t} />
  }

  let source = `
  <div id="fb-root"></div>
  <script async="1" defer="1" crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&amp;version=v11.0" nonce="k9oCRYbZ"></script>
  <div class="fb-page"
       data-href="${urlFacebook}" data-height="${height}"
       data-small-header="true" data-adapt-container-width="1" data-hide-cover="true" data-show-facepile="" data-show-posts="true"
       style="display: flex; justify-content: center; align-items: center;"
  ></div>
  `;

  return (
    <WebView
      style={{height: height-202, justifyContent: "center", alignItems: "center"}}
      source={{html: source}}
      javaScriptEnabled={true}
    />
  );
}

export const LinkedinTab = ({ t, item, online }) => {
  const urlLinkedin = item.extra_data.url_linkedin;
  if (!online || urlLinkedin == null) {
    return <EmptyContent t={t} />
  }
  return <BoutonGenerale  onPress={()=>{openUrl(urlLinkedin)}} title={t("Voir sur linkedin")} isActivate={true} size={"medium"} hasBorder={false}/>
}

async function  openUrl(url) {
  const supported = await Linking.canOpenURL(url);

  if(supported){
    await Linking.openURL(url);
  }else {
    alert(`Don't know how to open this URL: ${url}`);
  }
}


function groupLinksByField(links, field) {
  var by_id = {}
  links.forEach(link => {
    const data = link[field];

    var d = by_id[data.id];
    if (!d) {
      by_id[data.id] = {[field]: data, links: [link]}
    } else {
      d.links.push(link);
    }
  })

  return Object.keys(by_id).map(k => by_id[k]);
}

function groupLinksByContact(links) { return groupLinksByField(links, "poi_contact"); }
function groupLinksByEntity(links) { return groupLinksByField(links, "poi_entity"); }


export const NetworkTab = ({ navigation, item, type }) => {
  const getRelationContacts = () => {
      // entity tab for theme: mimic link format to contacts (they are directly linked to it)
      if (type === "theme") {
          return item.contacts.map(c => {
              return {link_target_type: "poi_contact", poi_contact: c, links: []}
          })
      } else {
          return groupLinksByContact(item.links_forward.concat(item.links_backward).filter((link) => {
              return link.link_target_type === 'poi_contact';
          }));
      }
  }

  const network = getRelationContacts();

  return <View>
    <View style={{height: 60, marginHorizontal: 10}}>
      <BarreRecherche  />
    </View>
    <TendanceList isEntityScreen={true} isExplorer={true} avatar={true} refNavigation={navigation}
		  isRefresh={false} refresh={()=>{}} type={'Contacts'} isLink={true} data={network} />
  </View>
}


export const EntityTab = ({ navigation, item, type }) => {
  const getRelationEntities = () => {
    // entity tab for theme: mimic link format to entities (they are directly linked to it)
    if (type === "theme") {
	return item.entities.map(c => {
	    return {link_target_type: "poi_entity", poi_entity: c, links: []}
	})
    } else {
	return groupLinksByEntity(item.links_forward.concat(item.links_backward).filter((link) => {
	    return link.link_target_type === 'poi_entity';
	}));
    }
  }

  const entities = getRelationEntities();

  return <View>
    <View style={{height: 60, marginHorizontal: 10}}>
      <BarreRecherche  />
    </View>
    <TendanceList isEntityScreen={true} isExplorer={true}  avatar={true} refNavigation={navigation}
		  isRefresh={false} refresh={false}  type={'Entity'} isLink={true} data={entities} />
  </View>
}



const uniqueArray = (arr1,arr2) => {
  const ids = arr1.map(item => item.id);
  return arr2.filter(item => !ids.includes(item.id));
}


export const BriefingTab = ({ navigation, route, item, type }) => {
  const [current_data, setData] = useState([]);
  const [isRefresh, setRefresh] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [currentCursorBriefing, setCurrentCursorBriefing] = useState(undefined);

  const _getBriefing = () => {
    // no more data to load
    if (currentCursorBriefing === false) { return; }

    setLoading(true);

    const query = {contact: [], entity: [], theme: []}
    query[type].push(item.id)

    customFeed(currentCursorBriefing, query.contact, query.entity, query.theme).then(resp => {
      const {data, cursor} = resp;
      // let d = this.uniqueArray(this.state.BriefingFeed, data);
      // save this as briefing
      // let feed = this.state.BriefingFeed.concat(d) ;

      setLoading(false);
      setCurrentCursorBriefing(cursor);
      setData(current_data.concat(data))
    });
  }

  // load once
  useEffect(() => { _getBriefing(); }, [])

  // FIXME: isExplorer: false?!
  // FIXME: isRefresh: never set
  return <PostList
    isExplorer={true}
    refNavigation={navigation}
    route={route}
    isRefresh={isRefresh}
    loadMore={_getBriefing}
    refresh={_getBriefing}
    data={current_data} />

}


export const ParticipantTab = ({ navigation, participants, type }) => {
  const [search, setSearch] = useState("");

  const participant_links = filterMixedData(participants, search).map(x => {
    if ("name" in x) {
      return {link_target_type: "poi_entity", poi_entity: x, links: []}
    } else {
      return {link_target_type: "poi_contact", poi_contact: x, links: []}
    }
  })

  return <View>
    <View style={{height: 60, marginHorizontal: 10}}>
      <BarreRecherche search={setSearch} fullScreen={true} />
    </View>
    <TendanceList isEntityScreen={true} isExplorer={true}  avatar={true} refNavigation={navigation}
		  isRefresh={false} refresh={false} type={false} isLink={true} data={participant_links} />
  </View>
}
